import React, { useContext, useEffect, useRef, useState } from 'react'

import { Toast } from 'primereact/toast'
import { TabView, TabPanel } from 'primereact/tabview';

import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext'
import { setTitlePage } from '../../../Base/Services/Config/ConfigService'
import { Button } from 'primereact/button'
import CalendarWeek from '../../../Base/Components/Form/CalendarWeek'
import { getDatesProduccion } from '../../../Base/Services/Moment/Luxon'
import Card from '../../../Base/Components/Card/Card'
import ListadoRequisaTab from './ListadoRequisasTab'


import { getPermisoCostosUser } from '../../../API/IT/Usuarios/AccesosUserRequets'
import { getAgentesCompras } from '../../../API/Global/Agentes/AgentesRequests'
import { getRequisasDetalle, putEstadoDetalle } from '../../../API/Compras/Requisas/PurchareDetailsRequests'
import RequisicionComprasModalCURD from './CrudRequisa/RequisaComprasModalCrud'



import PurcharesDetails from './Detalles/PurcharesDetails'
import { Dialog } from 'primereact/dialog';
import { toastShow } from '../../../Base/Services/ToastService';
import ArchivosRequisicion from './CrudRequisa/Encabezado_Requisicion/ArchivosRequisicion';
import { InputTextarea } from 'primereact/inputtextarea';
import { ArchivosExcelService } from '../../../Base/Services/ArchivosService';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { getListadoRequisas } from '../../../API/Compras/Requisas/PurchaseRequests';




const PurchareRequestsScreen = () => {

    const { userAuth } = useContext(AuthContext);

    const toast = useRef(null);
    const toastDialog = useRef(null);

    const [loading, setLoading] = useState(false);
    const [accesoColumnas, setAccesoColumnas] = useState([]);
    const [agentesCompras, setAgentesCompras] = useState([]);
    const [dates, setDates] = useState([new Date(), new Date()]);
    const [requisas, setRequisas] = useState([]);
    const [detalles, setDetalles] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [requisaEdit, setRequisaEdit] = useState(null);
    const [selectedDetalle, setSelectedDetalle] = useState([]);
    const [loadingExo, setLoadingExo] = useState(false);
    const [showDialogExo, setShowDialogExo] = useState(false);
    const [jsonExoneraciones, setJsonExoneraciones] = useState(null);






    const obtenerAccesoColumnas = async () => {
        const tempo = await getPermisoCostosUser((userAuth.idUser));
        if (tempo.length > 0) {
            setAccesoColumnas(tempo);
        }
    }

    const obtenerAgentesCompras = async () => {
        const tempo = await getAgentesCompras();
        let lista = [];
        let Agents = [];
        tempo.forEach((e) => {
            Agents.push(e)
            lista.push(e.AgentName);
        });
        setAgentesCompras(Agents)
    }

    const getInicialValues = () => {
        setLoading(true);
        obtenerAgentesCompras();
        obtenerAccesoColumnas();
        setLoading(false);
    }


    const getInfo = async () => {
        setLoading(true);
        const d = getDatesProduccion(dates);
        const t = await getRequisasDetalle(d);
        const r = await getListadoRequisas(d);
        setRequisas(r);
        setDetalles(t);
        setLoading(false);
    }

    const clear = () => {
        setRequisaEdit(null);
    }

    const confirmar = (tipo) => {
        if (selectedDetalle.length > 0) {
            confirmDialog({
                message: 'Esta seguro que desea cambiar el estado de la requisa',
                header: tipo === 1 ? 'Detener' : 'Cancelar',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: "Si",
                accept: () => changeEstadoDetalle(tipo),
                reject: null,
                rejectLabel: "No",
                style: { backgroundColor: "white" }
            });
        } else {
            toastShow(toast, 'error', 'No se puede cancelar', 'Selececcione el producto a Cancelar');
        }
    };

    const changeEstadoDetalle = (tipo) => {
        selectedDetalle.forEach((select) => {
            const tempo = detalles;
            const index = tempo.findIndex(detail => detail.IdPurcharesRequestDetail === select.IdPurcharesRequestDetail);
            if (tempo[index].IdEstado !== 3333) {
                tempo[index].IdEstado = tipo === 1 ? 3332 : 3327;
                tempo[index].EstadoPD = tipo === 1 ? "Detenido" : "Cancelado";
                putEstadoDetalle({ IdPurcharesRequestDetail: tempo[index].IdPurcharesRequestDetail, TipoEstado: tipo });
                getInfo();
            } else {
                toastShow(toast, 'error', 'No se puede cancelar', 'El producto ya se encuentra en una Orden de compras.');
            }
        })
    }

    const getExoneraciones = async () => {
        setLoadingExo(true);
        if (jsonExoneraciones?.length > 0) {
            const t = []
            let exo = []
            try {
                exo = JSON.parse(jsonExoneraciones);
            } catch (error) {
                console.log(error.toString());
                toastShow(toastDialog, 'error', 'Error al generar el archivo', error.toString())
            }
            if (exo?.length > 0) {
                exo.forEach(exo => {
                    if (exo?.listado) {
                        exo.listado.forEach(item => {
                            t.push({
                                "Orden compra": exo.ordenCompra,
                                "Descripcion": item.DESCRIPCION_ARANCELARIA,
                                "Cantidad autorizado": item.CANTIDAD_AUTORIZADA,
                                "Cantidad devengado": item.CANTIDAD_DEVENGADA,
                                "Codigo arancelario": item.CODIGO_ARANCELARIO,
                            })
                        })
                    }
                    if (exo?.servicios) {
                        exo.servicios.forEach(ser => {
                            t.push({
                                "Orden compra": exo.ordenCompra,
                                "Descripcion": ser.DESCRIPCION,
                                "Monto autorizado": ser.MONTO_AUTORIZADO,
                                "Monto devengado": ser.MONTO_AUTORIZADO,
                                "Servicio": ser.SERVICIO,
                            })
                        })
                    }
                })
            }
            console.log(t);
            if (t.length > 0) {
                ArchivosExcelService(t, 'Exoneraciones')
            } else {
                toastShow(toastDialog, 'warn', 'No hay datos')
            }
        } else {
            toastShow(toastDialog, 'warn', 'Ingresar listado de exoneraciones')
        }
        setLoadingExo(false);
    }


    useEffect(() => {
        getInicialValues();
        getInfo()
        setTitlePage('Requisas compras');
    }, [])

    return (
        <div>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Dialog visible={showDialog} onHide={e => { clear(); setShowDialog(false) }} maximizable closeOnEscape={false} maximized >
                <RequisicionComprasModalCURD idRequisa={requisaEdit} showDialog={showDialog} />
            </Dialog>
            <Card
                titulo={<div className='botones'>
                    <h2>Requisas compras</h2>
                    <CalendarWeek
                        date={dates}
                        setDate={setDates}
                        // buscar={getInfo}
                        selectionMode='range'
                    />
                    <Button icon='pi pi-search' tooltip='Buscar' onClick={getInfo} />
                    <Button icon='pi pi-plus' tooltip='Nueva' onClick={e => setShowDialog(true)} />

                    <Button icon="pi pi-stop-circle" type='submit' className="p-button-danger listado__botones" onClick={() => confirmar(1)}
                        tooltip="Detener" tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} style={{ marginLeft: 1.5 }} />


                    <Button icon='pi pi-print' tooltip='Imprimir' onClick={e => {
                        if (selectedDetalle.length === 0) {
                            toastShow(toast, 'warn', 'Advertencia', 'Seleccione una requisicion a imprimir');
                            return;
                        }
                        window.open(`${process.env.REACT_APP_ENV}/PurchaseRequest/print/${selectedDetalle[0]?.PurchaseRequest}`, selectedDetalle[0]?.PurchaseRequest, 'height=1200,width=1000')
                    }} />
                    <ArchivosRequisicion selected={selectedDetalle} />

                    <Button icon="pi pi-times" type="button" className="p-button-danger listado__botones" onClick={() => confirmar(2)}
                        tooltip="Cancelar" tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} style={{ marginLeft: 1.5 }} />

                    {[289, 288].includes(userAuth?.idUser) && <Button loading={loadingExo} icon="pi pi-table" type="button" className="listado__botones" onClick={() => setShowDialogExo(true)}
                        tooltip="Exoneraciones" tooltipOptions={{ className: 'purple-tooltip', position: 'top' }} style={{ marginLeft: 1.5 }} />}

                </div>}

                contenido={<div className='pt-4' >
                    <TabView>
                        <TabPanel header='Requisas'>
                            <PurcharesDetails
                                detalles={detalles}
                                accesoColumnas={accesoColumnas}
                                toast={toast}
                                loading={loading}
                                setDetalles={setDetalles}
                                setShowDialog={setShowDialog}
                                setRequisaEdit={setRequisaEdit}
                                selectedDetalle={selectedDetalle}
                                setSelectedDetalle={setSelectedDetalle}
                            />
                        </TabPanel>
                        <TabPanel header='Listado'>
                            <ListadoRequisaTab
                                listadoRequisas={requisas}
                                loading={loading}
                            />
                        </TabPanel>
                    </TabView>
                </div>}
            />

            <Dialog visible={showDialogExo}
                header={<div><h3>Exoneraciones</h3></div>}
                onHide={e => {
                    setJsonExoneraciones('');
                    setShowDialogExo(false);
                }}
            >
                <div>
                    <Toast ref={toastDialog} style={{ zIndex: 10000 }} />

                    <div>
                        <InputTextarea
                            value={jsonExoneraciones}
                            onChange={e => setJsonExoneraciones(e.target.value)}
                            rows={30}
                            cols={200}
                        />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                        <Button
                            onClick={e => {
                                setJsonExoneraciones('');
                            }}
                            label="Limpiar"
                            icon={'pi pi-trash'}
                        />
                        <Button
                            onClick={getExoneraciones}
                            label="Generar"
                            icon={'pi pi-save'}
                        />
                    </div>
                </div>
            </Dialog>

        </div>
    )
}

export default PurchareRequestsScreen